import { render, staticRenderFns } from "./gameStatus.vue?vue&type=template&id=764e634e"
import script from "./gameStatus.vue?vue&type=script&lang=js"
export * from "./gameStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports